export default "__VITE_ASSET__DBv9SPzu__"